var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusIconReturned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 23.094 24",
    width: 23.094,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Return",
    transform: "translate(-17469.453 4804)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    id: "Back",
    transform: "translate(17469.453 -4804)",
    width: 23.094
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.547,0H1.453V16.969H6.162L11.3,20.392V18.375H12a2.109,2.109,0,0,1,0,4.219V24h1.406a4.921,4.921,0,0,0,4.446-7.031h4.694ZM9.891,1.406h4.219V6.084L12,3.974,9.891,6.084Zm7.031,17.672a3.519,3.519,0,0,1-1.835,3.087A3.515,3.515,0,0,0,12,16.969H9.891v.8l-2.248-1.5,2.248-1.5v.8h3.516A3.52,3.52,0,0,1,16.922,19.078Zm4.219-3.516H16.847a4.905,4.905,0,0,0-3.441-1.406H11.3V12.139L6.162,15.563h-3.3V1.406H8.484V9.479L12,5.963l3.516,3.516V1.406h5.625Z",
    fill: "#ffff",
    id: "return_4556080",
    transform: "translate(17469 -4804)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIconReturned);
export default __webpack_public_path__ + "static/media/status_icon_returned.8cd0562e31bf2f6c72e0112df4db67ee.svg";
export { ForwardRef as ReactComponent };